import { graphql } from "@/data-access/graphql";
import { ScheduledBriefingFragment } from "../fragments/scheduled-briefing-fragments";

export const CreateScheduledBriefing = graphql(
  `
  mutation createScheduledBriefing($input: ScheduledBriefingInput!) {
    createScheduledBriefing(input: $input) {
      ... on ScheduledBriefingType {
        ...ScheduledBriefingFragment
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
  `,
  [ScheduledBriefingFragment],
);

export const GetScheduledBriefing = graphql(
  `
  query GetScheduledBriefing($filters: ScheduledBriefingFilter!) {
    scheduledBriefings(filters: $filters) {
      ...ScheduledBriefingFragment
    }
  }
  `,
  [ScheduledBriefingFragment],
);

/** @lintignore Reserved for scheduled briefings table list; edit fetch uses {@link GetScheduledBriefing}. */
export const GetScheduledBriefings = graphql(
  `
  query GetScheduledBriefings(
    $filters: ScheduledBriefingFilter
    $pagination: OffsetPaginationInput
  ) {
    scheduledBriefings(filters: $filters, pagination: $pagination) {
      ...ScheduledBriefingFragment
    }
  }
  `,
  [ScheduledBriefingFragment],
);

export const UpdateScheduledBriefing = graphql(
  `
  mutation updateScheduledBriefing($input: ScheduledBriefingUpdateInput!) {
    updateScheduledBriefing(input: $input) {
      ... on ScheduledBriefingType {
        ...ScheduledBriefingFragment
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
  `,
  [ScheduledBriefingFragment],
);

export const DeleteScheduledBriefing = graphql(`
  mutation deleteScheduledBriefing($scheduledBriefingId: ID!) {
    deleteScheduledBriefing(scheduledBriefingId: $scheduledBriefingId) {
      ... on SuccessResponse {
        __typename
        message
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
`);

export const GenerateScheduledBriefingPdfPreview = graphql(`
  mutation generateBriefingPdfPreview($input: GenerateBriefingPdfPreviewInput!) {
    generateBriefingPdfPreview(input: $input) {
      ... on BriefingPDFPreviewResponse {
        __typename
        url
      }
      ... on OperationInfo {
        __typename
        messages {
          field
          message
          code
        }
      }
    }
  }
`);
